  if (!customElements.get('qpdf-paypal-message')) {
    customElements.define(
      'qpdf-paypal-message',
      class QpdfPaypalMessage extends HTMLElement {
        constructor() {
          super();
          this.maxRetries = 40;
          this.retryDelay = 150;
          this.retryCount = 0;
          this.retryTimer = null;
          this.isRendered = false;
          this.isRendering = false;
          this.handlePaypalReady = this.tryRender.bind(this);
        }

        connectedCallback() {
          window.addEventListener('paypal:ready', this.handlePaypalReady, { once: true });
          this.tryRender();
        }

        disconnectedCallback() {
          if (this.retryTimer) {
            clearTimeout(this.retryTimer);
            this.retryTimer = null;
          }
          window.removeEventListener('paypal:ready', this.handlePaypalReady);
        }

        getPaypalConfig() {
          const amount = this.getAttribute('data-pp-amount');
          const placement = this.getAttribute('data-pp-placement') || 'product';
          const layout = this.getAttribute('data-pp-style-layout') || 'text';
          const logoType = this.getAttribute('data-pp-style-logo-type') || 'alternative';
          const textColor = this.getAttribute('data-pp-style-text-color') || 'black';
          const textSize = Number(this.getAttribute('data-pp-style-text-size') || 12);

          return {
            amount: amount ? Number(amount) : undefined,
            placement: placement,
            style: {
              layout: layout,
              logo: {
                type: logoType,
              },
              text: {
                color: textColor,
                size: textSize,
              },
            },
          };
        }

        tryRender() {
          if (this.isRendered || this.isRendering || !this.isConnected) return;

          if (!window.paypal || !window.paypal.Messages) {
            this.scheduleRetry();
            return;
          }

          this.isRendering = true;

          try {
            window.paypal.Messages(this.getPaypalConfig()).render(this);
            this.isRendered = true;
            this.dataset.qpdfPaypalRendered = 'true';
          } catch (error) {
            console.warn('[q-product-custom-box] PayPal message render failed:', error);
            this.scheduleRetry();
          } finally {
            this.isRendering = false;
          }
        }

        scheduleRetry() {
          if (this.retryCount >= this.maxRetries || this.retryTimer || !this.isConnected) return;

          this.retryCount += 1;
          this.retryTimer = setTimeout(() => {
            this.retryTimer = null;
            this.tryRender();
          }, this.retryDelay * this.retryCount);
        }
      }
    );
  }

  if (window.paypal && window.paypal.Messages) {
    window.dispatchEvent(new Event('paypal:ready'));
  } else {
    window.addEventListener('load', () => {
      if (window.paypal && window.paypal.Messages) {
        window.dispatchEvent(new Event('paypal:ready'));
      }
    });
  }